import { request } from '../request'

export function getLmwhList (data) {
  return request({
    url: '/columns',
    method: 'get',
    data
  })
}

export function addLmwh (data) {
    return request({
      url: '/columns',
      method: 'POST',
      data
    })
}

// 关键字查询
export function searchByKeyword (data) {
  return request({
    url: '/app/notice',
    method: 'get',
    data
  })
}
